module.exports = __webpack_public_path__ + "img/hr-branch-particle-28.45c0b361.png";